import { createSelector } from 'reselect';
import { MediaType } from '../../types/media';
import { Selector } from '../rootReducer';
import { getAllImportedMedia } from './imported/selectors';
import { IImportedMediaItem } from './imported/types';
import { isUploadInProgress } from './types';
import { getUploads } from './uploads/selectors';

const getAllMedia: Selector<IImportedMediaItem[]> = createSelector(
  [getAllImportedMedia, getUploads],
  (imported, uploads) => [...uploads, ...imported],
);

const getSelectedMedia: Selector<IImportedMediaItem[]> = createSelector(
  getAllMedia,
  (media) => media.filter((item) => item.selected),
);

const getSelectedImages: Selector<IImportedMediaItem[]> = createSelector(
  getSelectedMedia,
  (media) => media.filter((item) => item.type === MediaType.IMAGE),
);

const getSelectedVideos: Selector<IImportedMediaItem[]> = createSelector(
  getSelectedMedia,
  (media) => media.filter((item) => item.type === MediaType.VIDEO),
);

const getSelectedMediaCount: Selector<number> = createSelector(
  getSelectedMedia,
  (items) => items.length,
);

const getSelectedImagesCount: Selector<number> = createSelector(
  getSelectedImages,
  (images) => images.length,
);

const getSelectedVideosCount: Selector<number> = createSelector(
  getSelectedVideos,
  (videos) => videos.length,
);

const getUploadingMediaCount: Selector<number> = createSelector(
  getUploads,
  (items) => items.filter(isUploadInProgress).length,
);

const getSelectedMediaURLs: Selector<string[]> = createSelector(
  getSelectedMedia,
  (media) => media.map((item) => item.url),
);

const hasAnyMedia = createSelector(getAllMedia, (media) => media.length > 0);

export {
  getAllMedia,
  getSelectedMedia,
  getSelectedMediaCount,
  getSelectedMediaURLs,
  getSelectedImagesCount,
  getSelectedVideosCount,
  getUploadingMediaCount,
  hasAnyMedia,
};
export {
  mediaImportStatus,
  isShowImportNotification,
} from './imported/selectors';
